<template lang="pug">
v-dialog(v-model='isOpen' max-width='600px' persistent scrollable)
  v-card(height='220')
    v-card-title
      div(class='headline') Выделить этажы в отдельную структуру
    v-card-text(style='height: 300px' class="pt-0")
      v-row
        div(v-if='inSection>0') в {{inSection}} подъезде
      v-divider
      v-row
        v-text-field(
          :error='errors.has("floorsToExtract")'
          :error-messages='errors.first("floorsToExtract")'
          v-model='model.floorsToExtract'
          label='Укажите номера подъездов через "," или диапазоны через "-"'
        )
    v-card-actions
      v-spacer
      v-btn(flat @click="$emit('undo')") Отмена
      v-btn(
        flat,
        color="primary",
        @click="extractFloors",
        :disabled="model.floorsToExtract===null"
      ) Выделить
</template>

<script>
import http from '@/http'
import { get, each, isObject } from 'lodash'
export default {
  props: ['floorId', 'isOpen','inSection'],
  data: () => ({
    model: {
      floorsToExtract: null
    }
    
  }),
  mounted() {
      
  },
  methods: {
    extractFloors() {
      if (this.model.floorsToExtract !== null) {
        this.$validator.errors.clear()
        http
          .post(`/complexes/floors/${this.floorId}/extract?floorNumbers=` + this.model.floorsToExtract)
          .then(res => this.$emit('extractSuccess', res.data))
          .catch(error => {
            const errors = get(error, 'response.data.errors', false)
            if (isObject(errors)) {
              // Серверная валидация: выводим под единственным полем диалога
              this.$nextTick(() =>
                each(errors, msg =>
                  this.$validator.errors.add({
                    field: 'floorsToExtract',
                    msg: msg.join(', ')
                  })
                )
              )
            } else {
              this.$showServerErrors(error)
            }
          })
      }
    }
  }
}
</script>